import React from 'react';
import { SmileIcon, CheckCircleIcon, NetworkIcon, ShieldCheckIcon } from 'lucide-react';
export function ImpactSection() {
  const impacts = [{
    icon: SmileIcon,
    title: '7 años de trayectoria',
    description: 'Acompañando familias de niños neurodiversos de manera privada antes de constituirnos como fundación'
  }, {
    icon: CheckCircleIcon,
    title: 'Constituida en 2025',
    description: 'Organización sin fines de lucro fundada el 25 de noviembre de 2025 en Florida'
  }, {
    icon: NetworkIcon,
    title: '3 programas activos',
    description: 'Beca Semilla, Beca Crecer y Alianzas Estratégicas para apoyar el desarrollo integral'
  }, {
    icon: ShieldCheckIcon,
    title: 'En construcción',
    description: 'Desarrollando nuestro programa oficial de becas para medir y publicar indicadores de impacto'
  }];
  return <section id="impacto" className="py-20 px-4 sm:px-6 lg:px-8" style={{
    background: 'linear-gradient(to bottom, #f0f9e8, #ffffff)'
  }} data-id="element-101" data-mp="87w25edhrysu">
      <div className="max-w-6xl mx-auto" data-id="element-102" data-mp="1m73zdcaja5y9">
        <h2 className="text-3xl sm:text-4xl font-bold text-dark text-center mb-12" data-id="element-103" data-mp="1m8ezn24rsvkm">
          Nuestro Impacto
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-104" data-mp="1cgixnfzkclb4">
          {impacts.map((impact, index) => <div key={index} className="bg-white rounded-xl p-6 text-center shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-105" data-mp="18exp26u2at6q" data-mpi={index}>
              <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-4" data-id="element-106" data-mp="yfoq0zkcaodi">
                <impact.icon className="w-7 h-7 text-primary" data-id="element-107" data-mp="tigehhtp5il8" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-108" data-mp="2suragiuj7g9k">
                {impact.title}
              </h3>
              <p className="text-sm text-gray-600" data-id="element-109" data-mp="2nwhggbkjmlpj">{impact.description}</p>
            </div>)}
        </div>
        <div className="max-w-3xl mx-auto mb-10" data-id="element-110" data-mp="m4o0zqu7u4d3">
          <img src="https://cdn.magicpatterns.com/uploads/aUg3Kejn6x6VgUNoJWjDsh/heylloyd-image-1782596170904.png" alt="Familia caminando unida hacia un nuevo camino" className="w-full h-72 object-cover rounded-2xl shadow-lg" data-id="element-111" data-mp="qwp9r2s6dcyd" />
        </div>
        <div className="bg-white/70 rounded-2xl p-8 border-l-4 border-primary shadow-md" data-id="element-112" data-mp="14wqit5ilfqox">
          <p className="text-xl italic text-dark text-center" data-id="element-113" data-mp="14uxdbtjpvcii">
            "El mayor impacto ha sido acompañar durante siete años a familias
            que buscaban orientación para comprender mejor las necesidades de
            sus hijos"
          </p>
        </div>
      </div>
    </section>;
}